import { parseRequestError } from '@/common/utilities.ts'
import axiosInstance from '@/libs/axios_config.ts'
import {
  MarketplaceAffiliationPaginated,
  MarketplaceAffiliationPaginatedSchema,
  MarketplaceStorePaginated,
  MarketplaceStorePaginatedSchema,
} from '@/queries/marketplace/schema.ts'

export const GETMarketplaceStores = async (
  programId?: number,
  business_type?: string,
  search?: string,
  acceptingNewClients?: number,
  perPage: number = 10,
  page: number = 1,
  mySchools: boolean = false
): Promise<MarketplaceStorePaginated> => {
  try {
    const response = await axiosInstance.get(`/scholar/marketplace/stores`, {
      params: {
        program_id: programId,
        ...(business_type && { business_type }),
        search,
        accepting_new_clients: acceptingNewClients,
        per_page: perPage,
        page,
        ...(mySchools && { my_schools: 1 }),
      },
    })

    return MarketplaceStorePaginatedSchema.parse(response.data)
  } catch (error) {
    throw new Error(parseRequestError(error).message)
  }
}

export const GETMarketplaceItemsByProvider = async (
  programId: number,
  providerId: number,
  business_type?: string,
  search?: string,
  perPage?: number,
  page?: number
): Promise<any[]> => {
  const response = await axiosInstance.get(`/scholar/marketplace/items`, {
    params: {
      program_id: programId,
      provider_id: providerId,
      ...(business_type && { business_type }),
      ...(search && { search }),
      per_page: perPage,
      page,
    },
  })
  return response.data
}

export const GETMarketplaceAffiliations = async (
  programId?: number,
  search?: string,
  acceptingNewClients?: number,
  perPage: number = 10,
  page: number = 1
): Promise<MarketplaceAffiliationPaginated> => {
  try {
    const response = await axiosInstance.get(
      `/scholar/marketplace/affiliations`,
      {
        params: {
          program_id: programId,
          ...(search && { search }),
          accepting_new_clients: acceptingNewClients,
          per_page: perPage,
          page,
        },
      }
    )

    return MarketplaceAffiliationPaginatedSchema.parse(response.data)
  } catch (error) {
    throw new Error(parseRequestError(error).message)
  }
}
